export default {
  sector_name: "",
  name: "",
  lot: 0,
}
